import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavController} from "@ionic/angular";
import {ModelProvider} from "../../providers/modelProvider/ModelProvider";
import {NavigationExtras} from "@angular/router";
import {BusinessService} from "../../../core/services/BusinessService";
import {PopoverController} from "@ionic/angular";
import {SelectBarComponent} from "../../../app/shaps/components/select-bar/select-bar.component";
import {Events} from "../../providers/events";
import {ModelToolsProvider} from "../../providers/model-tools/model-tools";
import {AdminService} from "../../../core/services/AdminService";

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
})
export class PagesComponent implements OnInit, OnDestroy {
    @Input()
    reportModels;

    @Input()
    vertical;

    @Input()
    miniDisplay;
    @Input()
    sideBoxMode;
    @Input()
    exTableData;

    //forceDisplay - show this buttons automatically
    @Input()
    forceDisplay;

    @Input()
    showTitle = true;
    @Input()
    title;
    @Input()
    sectionName;
    @Input()
    tableParams: any;
    @Input()
    prefix;
    @Input()
    report;
    @Input()
    baseFilter = {};
    @Input()
    filters;
    @Input()
    inEditMode;

    //on extenral field from other model
    @Input()
    fieldType;
    @Input()
    fieldData;

    searchWaitTimeout;

    type;
    searchText = '';

    totalCount;

    totalPages;
    countRange;
    page = 1;
    rowsPerPage = 50;

    @Input()
    showPages = false;

    showSearch = false;
    showSettings = false;
    showFilters = true;

    showFilterOn = false;
    filterOptionsData;
    quickAddModel;

    @Input()
    tableFilters;
    @Input()
    showButtons = ['title', 'trash', 'search', 'add', 'refresh', 'settings', 'edit', 'adminData', 'map', 'calendar',
        'refresh', 'cube', 'calculator',
        'funnel', 'sideFilterTable', 'search',
        'paste', 'copy', 'tableDesc', 'customTableMarkAction'
    ];

    displayType = 'table';
    onloading = false;
    tableData;
    models;
    reports;
    needSave;
    filterTab;

    //show filters
    funnelFilters = false;
    showCalc = false;
    showAdd = false;

    //select on side table
    lastSelectedModel;

    //if split field is selected. will split table by this selected field.
    splitField;
    adminData;

    constructor(public events: Events,
                public adminService: AdminService,
                public modelTools: ModelToolsProvider,
                public modelProvider: ModelProvider,
                public businessService: BusinessService,
                public navCtrl: NavController, public popoverCtrl: PopoverController) {
    }

    ngOnInit() {
        // //console.log'pages!');
        // //console.logthis.sectionName);
        // //console.logthis.exTableData);
        // this.models = this.exTableData[this.sectionName];
        ////console.logthis.models);

        this.tableData = this.exTableData[this.sectionName + 'Data'];

        if (!this.tableData) {
            return;
        }
        if (!this.tableParams) {
            this.tableParams = this.tableData;
        }
        // console.log(this.baseFilter)

        //auto open filter
        // if (this.tableData['autoOpenFilter'] && this.businessService.screenSize[0] > 500) {
        //     this.filterTab = this.tableData['autoOpenFilter'];
        //     this.buttonClick('sideFilter', {'name': this.filterTab, 'filterTab': this.filterTab});
        // }

        // this.totalCount = this.reportModels['totalCount'];

        this.events.subscribe('showloading_' + this.prefix, (data) => {
            this.onloading = true;
        });
        this.events.subscribe('hideloading_' + this.prefix, (data) => {
            this.onloading = false;
        });

        this.events.subscribe('update_' + this.prefix, (data) => {
            me.onloading = false;
            this.needSave = false;

            //////console.log'update!!!');

            this.showFilters = false;
            setTimeout(function () {
                me.showFilters = true;
            });
        });
        // this.events.subscribe('onTaarifUpdate', (tableData) => {
        //
        //     this.needSave = false;
        //
        //     ////console.log'ot pages update!');
        //     ////console.logtableData);
        //
        //     this.onloading = false;
        //     this.exTableData = tableData;
        //     ////console.logthis.exTableData[this.sectionName + 'Data']);
        //
        //     //////console.log'update!!!', this.sectionName);
        //     if (this.exTableData[this.sectionName + 'Data']['filterOptionsData']) {
        //         this.filterOptionsData = this.exTableData[this.sectionName + 'Data']['filterOptionsData'];
        //     }
        //
        //     this.totalCount = this.exTableData[this.sectionName + 'Data']['totalCount'];
        //     this.totalPages = Math.ceil(this.totalCount / this.rowsPerPage);
        //     this.setPages();
        //
        //     this.showFilters = false;
        //     setTimeout(function () {
        //         me.showFilters = true;
        //     });
        // });


        this.events.subscribe('toSideFilterMode' + this.prefix, (active) => {
            this.filterTab = active;

            //close settings.
            if (active) {
                this.showSettings = false;
                this.sideBoxMode = true;
            } else {
                this.sideBoxMode = false;
            }

        });

        this.filterOptionsData = {};
        // for (let fieldKey in this.tableParams['filterOptions']) {
        //     this.filterOptionsData[fieldKey] = this.tableParams['filterOptions'][fieldKey];
        // }
        if (this.exTableData[this.sectionName + 'Data']['filterOptionsData']) {
            this.filterOptionsData = this.exTableData[this.sectionName + 'Data']['filterOptionsData'];
        }

        let me = this;
        this.events.subscribe('onModelsUpdate' + this.prefix, (tableData) => {
            this.onModelsUpdate(tableData[me.sectionName + 'Data']);
        });

        this.events.subscribe('rowCLick' + this.prefix, (tableData) => {
            this.needSave = true;
        });

        if (this.forceDisplay) {
            console.log('force display!!!')
            for (let k of this.forceDisplay) {
                console.log(k)
                this.showButtons.push(k);
            }
        }

    }

    getAdminData() {
        let me = this;

        if (me.adminData) {
            me.adminData = null;
            return
        }

        let filters = this.adminService.getMainFilters();
        filters['getModelTopReport'] = this.sectionName;
        this.modelProvider.list('report', filters)
            .then(function (data: any) {
                me.adminData = data['models'][0].data['finalResReport']['reportData'];
            });
    }

    async presentSelectBar(myEvent, type, bigPopup = false) {

        this.adminService.popupEditBoxByData(myEvent, {
            'prefix': this.prefix,
            'exTableData': this.exTableData,
            'sectionName': this.sectionName,
            'type': type
        }, bigPopup);

        // this.buttonClick(type);
        // const popover = await this.popoverCtrl.create({
        //     component: SelectBarComponent,
        //     componentProps: {
        //         'prefix': this.prefix,
        //         'exTableData': this.exTableData,
        //         'sectionName': this.sectionName,
        //         'type': type
        //     },
        //     event: myEvent,
        //     animated: true,
        //     showBackdrop: true,
        //     cssClass: 'note-popover icenter-popover smaller-popover'
        // });
        // return await popover.present();
    }

    ngOnDestroy(): void {
        this.events.unsubscribe('onModelsUpdate' + this.prefix);
        this.events.unsubscribe("onTaarifUpdate");
        this.events.unsubscribe('update_' + this.prefix);
        this.events.unsubscribe('showloading_' + this.prefix);
        this.events.unsubscribe('hideloading_' + this.prefix);
    }

    onModelsUpdate(tableData) {
        let me = this;
        this.totalCount = tableData['totalCount'];
        me.totalPages = Math.ceil(me.totalCount / me.rowsPerPage);
        this.setPages();

        this.tableData = tableData;
        if (!this.quickAddModel) this.quickAddModel = this.adminService.getNewModel(this.sectionName, this.exTableData);

        if (this.tableData['autoOpenFilters']) {
            this.funnelFilters = true;
        }
    }

    setPages() {
        let me = this;
        me.countRange = [1];
        let i = this.page > 2 ? this.page - 1 : 2;
        while (i < this.totalPages - 1) {
            me.countRange.push(i);
            i++;
            if (me.countRange.length > 4) {
                break;
            }
        }
        me.countRange.push(this.totalPages);


        // for (let i = 1; i <= me.totalPages; i++) {
        //     me.countRange.push(i);
        // }
        //
        // if (me.countRange.length > 7) {
        //     if (me.page > 7) {
        //         me.countRange.splice(0, me.countRange.indexOf(me.page) - 2)
        //     }
        //     me.countRange.splice(me.countRange.indexOf(me.page) + 4, me.countRange.length);
        // }
        // me.countRange = me.countRange.reverse();
    }

    refresh() {
        this.onloading = true;
        this.events.publish('refresh_request_' + this.prefix, {});
    }

    pageGo(i) {
        //console.log'change page: '+ i);

        // this.onloading = true;
        this.page = i;

        // let filters = {};
        // filters['sectionName'] = this.tableParams['modelPrefix'];
        // filters[this.sectionName + 'modelOffset'] = (this.page - 1) * this.rowsPerPage;
        // filters[this.sectionName + 'modelLimit'] = this.rowsPerPage;

        // this.events.publish('refresh_request_' + this.prefix, filters);
        this.events.publish("btnclick_" + this.prefix, {'key': 'addFilter', 'data': {'page': this.page}});

        this.setPages();
    }

    showFilter() {
        this.showFilterOn = !this.showFilterOn;

        // if (this.showFilterOn) {
        //     let me = this;
        //     this.modelProvider.list('report', {'type': this.filterPref}).then(function (res: any) {
        //         //////console.logres);
        //         me.reports = res.models;
        //     })
        // }
    }

    chooseReport(key) {
        let filters = {};
        if (key == -1) {
            filters = {
                'modelFilterId': -1,
                'filterOptionsData': JSON.stringify({}),
                'sectionName': this.tableParams['modelPrefix']
            };

        } else if (key == 'go') {
            filters = {
                'modelFilterId': -1,
                'filterOptionsData': JSON.stringify(this.filterOptionsData),
                'sectionName': this.tableParams['modelPrefix']
            };
        } else {
            filters = {
                'modelFilterId': key,
                'sectionName': this.tableParams['modelPrefix']
            };
        }

        this.onloading = true;

        this.buttonClick('customFilter', filters);
        // this.events.publish('refresh_request_' + this.prefix, filters);
    }

    buttonClick(key, data = null) {
        this.events.publish("btnclick_" + this.prefix, {'key': key, 'data': data});
    }

    searchWait() {
        if (!this.searchText || this.searchText.length <= 1) {
            return;
        }

        clearTimeout(this.searchWaitTimeout);

        let me = this;
        this.searchWaitTimeout = setTimeout(function () {
            me.search();
        }, 3000);
    }

    search() {
        clearTimeout(this.searchWaitTimeout);
        let filters = {};
        this.page = 1;
        // filters[this.sectionName + 'modelOffset'] = 0;
        // filters[this.sectionName + 'modelLimit'] = this.rowsPerPage;
        // filters['sectionName'] = this.tableParams['modelPrefix'];
        // filters['modelPrefix'] = this.tableParams['modelPrefix'];
        filters['searchText'] = this.searchText;
        // filters['offset'] = 0;

        //////console.logthis.searchText);
        //////console.logthis.prefix);
        //////console.logfilters);
        this.buttonClick('search', filters);

        // this.setPages();
        // this.events.publish('refresh_request_' + this.prefix, filters);
    }

    openCustomModel(sectionName, rowIndex = null, baseFilter = null) {
        ////console.log'open custom model: ', sectionName);
        let params = {
            'sectionName': sectionName,
            'rowIndex': rowIndex,
            'baseFilter': baseFilter
        };

        let navigationExtras: NavigationExtras = {
            queryParams: params
        };

        this.navCtrl.navigateForward('admin-model/' + this.sectionName + rowIndex, navigationExtras);
    }

    //??? not done here..
    customTableAction(tableData) {
        if (tableData['type'] == 'searchDevice') {
            this.navCtrl.navigateForward('searchDevice');
        }
        if (tableData['type'] == 'callServer') {
            this.modelProvider.custom(tableData['requestPrefix']).then((data: any) => {
                //console.log'its back!');
            });
        }
    }

    getSelectTableFields(fields) {
        return fields.filter(field => field['type'] == 'selectTable');
    }

}